import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyArS8RmirBzEkA1DYuZpuNasq2f_laQEkw",
  authDomain: "adder-haus.firebaseapp.com",
  projectId: "adder-haus",
  storageBucket: "adder-haus.firebasestorage.app",
  messagingSenderId: "358260937305",
  appId: "1:358260937305:web:ac4936524621dd3d055748",
  measurementId: "G-DXEQ3JMM6N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Cloud Functions — region must match where functions are deployed
// (see functions/functions/functions/src, region 'asia-south1')
export const functions = getFunctions(app, 'asia-south1');

export default app;